module.exports = {"values":["Arrows","Crossbow Bolts","Sling Bullets","Blowgun Needles","Bullets","Energy cells"]}


//////////////////
// WEBPACK FOOTER
// ./src/item-helpers/AmmunitionTypes.json
// module id = 549
// module chunks = 0